import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { API_URLS } from '../config/api';
import { 
  ChevronDown, 
  ChevronUp, 
  HelpCircle
} from 'lucide-react';

const FAQSection = ({ sectionContent }) => {
  const [openItems, setOpenItems] = useState(new Set());
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    const loadFaq = async () => {
      try {
        const res = await fetch(API_URLS.FAQ);
        if (!res.ok) return;
        const data = await res.json();
        const cats = (data.categories || []).map(cat => ({
          id: cat.id,
          title: cat.title
        }));
        const questions = data.questions || [];
        // Filter to show only "genel" category
        const generalCategory = cats.find(cat => 
          cat.title.toLowerCase().includes('genel') || 
          cat.title.toLowerCase().includes('general')
        );
        
        if (generalCategory) {
          const genelQuestions = questions
            .filter(q => q.category_id === generalCategory.id)
            .map(q => ({ question: q.question, answer: q.answer }));
          setFaqs(genelQuestions);
        }
      } catch(e) {
        // keep empty
      }
    };
    loadFaq();
  }, []);

  const toggleItem = (questionIndex) => {
    const newOpenItems = new Set(openItems);
    
    if (newOpenItems.has(questionIndex)) {
      newOpenItems.delete(questionIndex);
    } else {
      newOpenItems.add(questionIndex);
    }
    
    setOpenItems(newOpenItems);
  };

  return (
    <div className="w-full">
      {/* Header */}
      <div className="text-center mb-12">
        <div className="inline-flex items-center space-x-3 bg-sky-100 text-sky-700 px-6 py-3 rounded-full text-lg font-medium mb-6">
          <HelpCircle className="w-6 h-6" />
          <span>{sectionContent?.badge_text || 'Sıkça Sorulan Sorular'}</span>
        </div>
        
        <h2 className="text-3xl font-bold text-center mb-12">
          {sectionContent?.title || 'Website Al hakkında en çok sorulan soruların yanıtlarını burada bulabilirsiniz.'}
        </h2>
        
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          {sectionContent?.description || 'ProWork hakkında en çok sorulan soruların yanıtlarını burada bulabilirsiniz. Aradığınızı bulamadıysanız 7/24 destek ekibimizle iletişime geçin.'}
        </p>
        <div className="mt-6">
          <Link to={sectionContent?.button_link || '/sikca-sorulan-sorular'} className="inline-flex items-center bg-sky-500 hover:bg-sky-600 text-white px-6 py-3 rounded-lg transition-colors">
            {sectionContent?.button_text || 'Tüm Sorular'}
          </Link>
        </div>
      </div>

      {/* FAQ Questions */}
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          {faqs.map((faq, questionIndex) => {
            const isOpen = openItems.has(questionIndex);
            
            return (
              <div key={questionIndex} className="border-b border-gray-200 last:border-b-0">
                <button
                  onClick={() => toggleItem(questionIndex)}
                  className="w-full px-6 py-4 text-left hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-center justify-between">
                    <h3 className="font-semibold text-gray-900 pr-4 flex items-center">
                      <HelpCircle className="w-5 h-5 mr-3 text-blue-600" />
                      {faq.question}
                    </h3>
                    {isOpen ? (
                      <ChevronUp className="w-5 h-5 text-sky-600 flex-shrink-0" />
                    ) : (
                      <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />
                    )}
                  </div>
                </button>
                
                {isOpen && (
                  <div className="px-6 pb-4">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

    </div>
  );
};

export default FAQSection;